import { render, staticRenderFns } from "./editUser.vue?vue&type=template&id=90fb07ce&scoped=true"
import script from "./editUser.vue?vue&type=script&lang=js"
export * from "./editUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fb07ce",
  null
  
)

export default component.exports